import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectPage, selectPageExtra } from '../../selectors/analytics';
import { selectUser } from '../../selectors/user';
import { IThunkApi } from '../../types/redux/store';
import { ICallbackClickValues, trackCallbackClick } from '../../utils/analytics';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

/**
 * Redux thunk action, отправляющий событие клика на "Заказать звонок" (успешный ответ от сервера)
 */
export const trackCallbackClickAction = createAsyncThunk<void, ICallbackClickValues, IThunkApiExtended>(
  'analytics/trackCallbackClickAction',
  async (values, { getState, extra: context }) => {
    try {
      const state = getState();
      const page = selectPage(state);
      const extra = selectPageExtra(state);
      const user = selectUser(state);

      trackCallbackClick({ page: { ...page, extra }, user, values });
    } catch (ex) {
      const { logger } = context;
      logger.error(ex, {
        domain: 'thunks/analytics/trackCallbackClickAction',
      });

      throw ex;
    }
  },
);
